import React, { useCallback, useEffect } from "react";
import Slider from "react-slick";
import {
  animationdoc,
  ExpertsImg1,
  ExpertsImg2,
  ExpertsImg3,
  ExpertsImg4,
} from "../../assets/images";
import "./doctor.scss";
import { Link, useLocation, useParams } from "react-router-dom";
import { elementsIcon } from "../../assets/icons";
import { PublicService } from "../../services";
import { useQuery } from "@tanstack/react-query";
import { Helmet } from "react-helmet";
import { categoryMeta } from "./metaConfig";
import { doctorDescription } from "./titleDesc";
import { schemaDataDoctors } from "./schemaDataDoctors";

const DoctorInternal = () => {
  const location = useLocation();
  const path = location.pathname.replace(/^\/+/, "");
  // console.log("path name", path, categoryMeta[path]);

  const { category } = useParams();
  const settings = {
    dots: false,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000,
    // waitForAnimate: false,
  };

  const { getDoctorList } = PublicService();
  const doctors = useQuery({
    queryKey: ["doctors"],
    queryFn: () =>
      getDoctorList({ page: 1, limit: 50, specializationSlug: category }),
  });
  // console.log("page cat" , doctors)
  // specialization: category
  const doctorsList = doctors?.data?.data?.doctors;
  // console.log('doctorsList internal', doctorsList)

  const updateData = doctorDescription[path];
  // console.log("update path", path);
  
  const updateSchema = schemaDataDoctors[path];
  // console.log("update schema", updateSchema);

  const CustomHelmet = useCallback(() => {
    const defaultDomain = "https://holypills.in";

    const meta = categoryMeta[path] || {
      title: "Doctors | Holypills",
      description: "Find expert doctors on Holypills.",
      canonical: `${defaultDomain}/${path}`,
    };
    // const orgnaizationData = {
    //   "@context": "https://schema.org",

    //   "@type": "MedicalOrganization",

    //   name: "Holypills",

    //   alternateName: "Holypills Homeopathy Platform",

    //   url: "https://www.holypills.in",

    //   logo: "https://holypills.in/static/media/logoblk.85a98ca03ea02020c9410dbb9412a5f5.svg",

    //   image: "https://www.holypills.in/banner.jpg",

    //   description:
    //     "Holypills is a trusted homeopathy care platform for women’s health. From PCOS and Endometriosis to Menopause and Postpartum recovery, we provide personalized remedies and app-based tracking to help you heal naturally.",

    //   founder: {
    //     "@type": "Person",

    //     name: "Dr. Ila Kathuria",

    //     jobTitle: "Co-Founder & Chief Homeopathy Consultant",

    //     image:
    //       "https://holypills.in/static/media/founder.643f6d9fcb22ed9aaddd.jpeg",

    //     description:
    //       "Dr. Ila Kathuria, a distinguished name in women’s health and one of India’s foremost advocates of personalized, integrative care. With over 35 years of clinical experience, Dr. Kathuria has consistently challenged the status quo in women’s healthcare by blending the depth of homeopathy with the precision of modern medical insight.",
    //   },

    //   foundingDate: "2025",

    //   sameAs: [
    //     "https://www.facebook.com/holypillscare",

    //     "https://www.instagram.com/holypillscare",

    //     "https://www.linkedin.com/company/holypillscare",

    //     "https://www.youtube.com/@Holypillscare",
    //   ],

    //   contactPoint: {
    //     "@type": "ContactPoint",

    //     telephone: "+91-9999887833",

    //     contactType: "customer service",

    //     availableLanguage: ["English", "Hindi"],
    //   },

    //   address: {
    //     "@type": "PostalAddress",

    //     streetAddress:
    //       "Connaught Place 4 - S, DCM Building Barakhamba Road, Landmark: Near Metro Station, Delhi, Delhi",

    //     addressLocality: "Delhi",

    //     addressRegion: "Delhi",

    //     postalCode: "110001",

    //     addressCountry: "IN",
    //   },
    // };


    return (
      <Helmet defer={false}>
        <title>{meta.title}</title>
        <link rel="canonical" href={meta.canonical} />
        <meta name="description" content={meta.description} />
        <meta property="og:site_name" content="Holypills" />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://yourdomain.com/${path}`} />
        <meta property="og:image" content="/src/assets/images/ogImage.jpg" />
        <meta name="twitter:image" content="/src/assets/images/ogImage.jpg" />
         <script type="application/ld+json">{JSON.stringify(updateSchema)}</script>
        {/* <script type="application/ld+json">
          {JSON.stringify(orgnaizationData)}
        </script> */}
      </Helmet>
    );
  }, [path]);

  useEffect(() => {
    doctors.refetch();
  }, [category]);
  return (
    <>
      <CustomHelmet />
      <div className="home_page wrapper_about_us_page wrapper_doctor_internal wrapper_pcos_page">
        <section className="wrap_bg_slider spacing">
          <div className="cnt_fixed">
            <h1>{updateData?.heroHeading}</h1>
            <p>{updateData?.heroDescription}</p>
            <p>{updateData?.heroDescriptionNew}</p>
          </div>
          <Slider {...settings}>
            <div className="wrap_img">
              <img src={animationdoc} alt="image" />
            </div>
            <div className="wrap_img" alt="image">
              <img src={animationdoc} />
            </div>
            <div className="wrap_img" alt="image">
              <img src={animationdoc} />
            </div>
          </Slider>
        </section>
        <div className="trusted_experts spacing">
          <div className="container">
            <div className="page_title">
              <h2>{updateData?.paraHeading}</h2>
              <p>{updateData?.shortContent}</p>
            </div>

            <div className="card_wrap">
              {doctorsList?.map((doctor, index) => {
                console.log("doctor", doctor);
                return (
                  <div className="item" key={index}>
                    <div className="image_wrap">
                      <img src={doctor?.profile} alt="ExpertsImg1" />
                    </div>
                    <div className="content">
                      <div className="tag">
                        <img src={elementsIcon} alt="icon" />
                        <span>{doctor?.specialization}</span>
                      </div>
                      <b>{doctor?.name} </b>
                      {/* <p>
                      {doctor?.qualification}
                    </p> */}
                      <Link to={`/doctors-details/${doctor?.slug}`}>
                        Explore More
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorInternal;
